import { render, staticRenderFns } from "./Titulo.vue?vue&type=template&id=8a68d796&scoped=true&lang=pug"
import script from "./Titulo.vue?vue&type=script&lang=js"
export * from "./Titulo.vue?vue&type=script&lang=js"
import style0 from "./Titulo.styl?vue&type=style&index=0&id=8a68d796&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a68d796",
  null
  
)

export default component.exports